import { CsvHeaderModel } from '../../../models/CsvHeader';

export const PRODUCT_FOR_UPLOAD_CATEGORIES_HEADER: CsvHeaderModel[] = [
  {
    label: 'itemcode',
    key: 'itemcode',
  },
  {
    label: 'mainGroup',
    key: 'mainGroup',
  },
  {
    label: 'Division',
    key: 'Division',
  },
  {
    label: 'Category',
    key: 'Category',
  },
  {
    label: 'SubCategory',
    key: 'SubCategory',
  },
  {
    label: 'productNameEn',
    key: 'productNameEn',
  },
  {
    label: 'productNameLa',
    key: 'productNameLa',
  },
  {
    label:'barcodes',
    key:"barcodes"
  },
  {
    label:'pack size',
    key:"quantity"
  },
  {
    label:'Status',
    key:"status"
  }
];
